import { render, staticRenderFns } from "./TrainingRegistrationCard.vue?vue&type=template&id=7f95b102&"
import script from "./TrainingRegistrationCard.vue?vue&type=script&lang=ts&"
export * from "./TrainingRegistrationCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports